/*! For license information please see react.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("react-dom")) : "function" == typeof define && define.amd ? define(["react", "react-dom"], t) : "object" == typeof exports ? exports.Passbase = t(require("react"), require("react-dom")) : e.Passbase = t(e.React, e.ReactDOM);
}(self, function (e, t) {
  return function () {
    var n = {
      875: function _(e, t, n) {
        var r;
        !function () {
          "use strict";

          var o = !("undefined" == typeof window || !window.document || !window.document.createElement),
              i = {
            canUseDOM: o,
            canUseWorkers: "undefined" != typeof Worker,
            canUseEventListeners: o && !(!window.addEventListener && !window.attachEvent),
            canUseViewport: o && !!window.screen
          };
          void 0 === (r = function () {
            return i;
          }.call(t, n, t, e)) || (e.exports = r);
        }();
      },
      942: function _(e, t, n) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });

        var r = function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
          }

          return function (t, n, r) {
            return n && e(t.prototype, n), r && e(t, r), t;
          };
        }(),
            o = n(787),
            i = n(156);

        function a(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function u(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }

        var c = function (e) {
          function t() {
            return a(this, t), u(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
          }

          return function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
          }(t, e), r(t, [{
            key: "componentDidMount",
            value: function value() {
              this.props.innerRef((0, i.findDOMNode)(this));
            }
          }, {
            key: "componentDidUpdate",
            value: function value(e) {
              e.children !== this.props.children && this.props.innerRef((0, i.findDOMNode)(this));
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              this.props.innerRef(null);
            }
          }, {
            key: "render",
            value: function value() {
              return this.props.children;
            }
          }]), t;
        }(o.Component);

        t.default = c;
      },
      345: function _(e, t, n) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(942);
        Object.defineProperty(t, "default", {
          enumerable: !0,
          get: function get() {
            return (e = r, e && e.__esModule ? e : {
              default: e
            }).default;
            var e;
          }
        });
      },
      781: function _(e, t, n) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });

        var r = function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
          }

          return function (t, n, r) {
            return n && e(t.prototype, n), r && e(t, r), t;
          };
        }(),
            o = n(787),
            i = f(o),
            a = n(875),
            u = n(590),
            c = f(n(274)),
            l = f(n(396)),
            s = n(468);

        function f(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }

        function p(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function d(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }

        var h = function (e) {
          function t() {
            return p(this, t), d(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
          }

          return function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
          }(t, e), r(t, [{
            key: "componentDidMount",
            value: function value() {
              a.canUseDOM && (this.initialHeight = window.innerHeight);
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              var e = window.innerHeight - this.initialHeight;
              e && window.scrollTo(0, window.pageYOffset + e), this.initialHeight = window.innerHeight;
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props.children;
              return e ? i.default.createElement(u.TouchScrollable, null, e) : null;
            }
          }]), t;
        }(o.PureComponent),
            y = (0, s.pipe)(l.default, c.default)(h),
            v = function v(e) {
          return e.isActive ? i.default.createElement(y, e) : e.children;
        };

        v.defaultProps = {
          accountForScrollbars: !0,
          children: null,
          isActive: !0
        }, t.default = v;
      },
      590: function _(e, t, n) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.TouchScrollable = void 0;

        var r = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];

            for (var r in n) {
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
          }

          return e;
        },
            o = function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
          }

          return function (t, n, r) {
            return n && e(t.prototype, n), r && e(t, r), t;
          };
        }(),
            i = n(787),
            a = s(i),
            u = n(875),
            c = s(n(345)),
            l = n(468);

        function s(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }

        function f(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function p(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }

        t.TouchScrollable = function (e) {
          function t() {
            var e, n, r;
            f(this, t);

            for (var o = arguments.length, i = Array(o), a = 0; a < o; a++) {
              i[a] = arguments[a];
            }

            return n = r = p(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(i))), r.getScrollableArea = function (e) {
              r.scrollableArea = e;
            }, p(r, n);
          }

          return function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
          }(t, e), o(t, [{
            key: "componentDidMount",
            value: function value() {
              u.canUseEventListeners && (this.scrollableArea.addEventListener("touchstart", l.preventInertiaScroll, l.listenerOptions), this.scrollableArea.addEventListener("touchmove", l.allowTouchMove, l.listenerOptions));
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              u.canUseEventListeners && (this.scrollableArea.removeEventListener("touchstart", l.preventInertiaScroll, l.listenerOptions), this.scrollableArea.removeEventListener("touchmove", l.allowTouchMove, l.listenerOptions));
            }
          }, {
            key: "render",
            value: function value() {
              return a.default.createElement(c.default, r({
                innerRef: this.getScrollableArea
              }, this.props));
            }
          }]), t;
        }(i.PureComponent);
      },
      606: function _(e, t, n) {
        "use strict";

        var r = n(781);
        Object.defineProperty(t, "ZP", {
          enumerable: !0,
          get: function get() {
            return (e = r, e && e.__esModule ? e : {
              default: e
            }).default;
            var e;
          }
        });
        var o = n(590);
        Object.defineProperty(t, "in", {
          enumerable: !0,
          get: function get() {
            return o.TouchScrollable;
          }
        });
      },
      468: function _(e, t, n) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.pipe = t.listenerOptions = void 0, t.preventTouchMove = function (e) {
          return e.preventDefault(), !1;
        }, t.allowTouchMove = function (e) {
          var t = e.currentTarget;
          return t.scrollHeight > t.clientHeight ? (e.stopPropagation(), !0) : (e.preventDefault(), !1);
        }, t.preventInertiaScroll = function () {
          var e = this.scrollTop,
              t = this.scrollHeight,
              n = e + this.offsetHeight;
          0 === e ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
        }, t.isTouchDevice = function () {
          return !!r.canUseDOM && ("ontouchstart" in window || navigator.maxTouchPoints);
        }, t.camelToKebab = function (e) {
          return e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        }, t.parse = function (e) {
          return isNaN(e) ? e : e + "px";
        }, t.getPadding = function () {
          if (!r.canUseDOM) return 0;
          var e = parseInt(document.body.paddingRight, 10) || 0,
              t = document.body ? document.body.clientWidth : 0;
          return window.innerWidth - t + e || 0;
        }, t.getWindowHeight = function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
          if (r.canUseDOM) return window.innerHeight * e;
        }, t.getDocumentHeight = function () {
          if (r.canUseDOM) return document.body.clientHeight;
        }, t.makeStyleTag = function () {
          if (r.canUseDOM) {
            var e = document.createElement("style");
            return e.type = "text/css", e.setAttribute("data-react-scrolllock", ""), e;
          }
        }, t.injectStyles = function (e, t) {
          r.canUseDOM && (e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t)));
        }, t.insertStyleTag = function (e) {
          r.canUseDOM && (document.head || document.getElementsByTagName("head")[0]).appendChild(e);
        };
        var r = n(875);
        t.listenerOptions = {
          capture: !1,
          passive: !1
        };

        var o = function o(e, t) {
          return function () {
            return t(e.apply(void 0, arguments));
          };
        };

        t.pipe = function () {
          for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          return t.reduce(o);
        };
      },
      274: function _(e, t, n) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });

        var r = function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
          }

          return function (t, n, r) {
            return n && e(t.prototype, n), r && e(t, r), t;
          };
        }();

        t.default = function (e) {
          return function (t) {
            function n() {
              var e, t, r;
              c(this, n);

              for (var o = arguments.length, i = Array(o), a = 0; a < o; a++) {
                i[a] = arguments[a];
              }

              return t = r = l(this, (e = n.__proto__ || Object.getPrototypeOf(n)).call.apply(e, [this].concat(i))), r.addSheet = function () {
                var e = r.getStyles(),
                    t = (0, u.makeStyleTag)();
                t && ((0, u.injectStyles)(t, e), (0, u.insertStyleTag)(t), r.sheet = t);
              }, r.getStyles = function () {
                var e = r.props.accountForScrollbars,
                    t = (0, u.getDocumentHeight)(),
                    n = e ? (0, u.getPadding)() : null;
                return "body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        " + (t ? "height: " + t + "px !important;" : "") + "\n        " + (n ? "padding-right: " + n + "px !important;" : "") + "\n      }";
              }, l(r, t);
            }

            return function (e, t) {
              if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
              e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }(n, t), r(n, [{
              key: "componentDidMount",
              value: function value() {
                this.addSheet();
              }
            }, {
              key: "removeSheet",
              value: function value() {
                this.sheet && (this.sheet.parentNode.removeChild(this.sheet), this.sheet = null);
              }
            }, {
              key: "componentWillUnmount",
              value: function value() {
                this.removeSheet();
              }
            }, {
              key: "render",
              value: function value() {
                return a.default.createElement(e, this.props);
              }
            }]), n;
          }(i.PureComponent);
        };

        var o,
            i = n(787),
            a = (o = i) && o.__esModule ? o : {
          default: o
        },
            u = n(468);

        function c(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function l(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }
      },
      396: function _(e, t, n) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });

        var r = function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
          }

          return function (t, n, r) {
            return n && e(t.prototype, n), r && e(t, r), t;
          };
        }();

        t.default = function (e) {
          return function (t) {
            function n() {
              return l(this, n), s(this, (n.__proto__ || Object.getPrototypeOf(n)).apply(this, arguments));
            }

            return function (e, t) {
              if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
              e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }(n, t), r(n, [{
              key: "componentDidMount",
              value: function value() {
                u.canUseDOM && (0, c.isTouchDevice)() && document.addEventListener("touchmove", c.preventTouchMove, c.listenerOptions);
              }
            }, {
              key: "componentWillUnmount",
              value: function value() {
                u.canUseDOM && (0, c.isTouchDevice)() && document.removeEventListener("touchmove", c.preventTouchMove, c.listenerOptions);
              }
            }, {
              key: "render",
              value: function value() {
                return a.default.createElement(e, this.props);
              }
            }]), n;
          }(i.PureComponent);
        };

        var o,
            i = n(787),
            a = (o = i) && o.__esModule ? o : {
          default: o
        },
            u = n(875),
            c = n(468);

        function l(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function s(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }
      },
      787: function _(t) {
        "use strict";

        t.exports = e;
      },
      156: function _(e) {
        "use strict";

        e.exports = t;
      }
    },
        r = {};

    function o(e) {
      var t = r[e];
      if (void 0 !== t) return t.exports;
      var i = r[e] = {
        exports: {}
      };
      return n[e](i, i.exports, o), i.exports;
    }

    o.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return o.d(t, {
        a: t
      }), t;
    }, o.d = function (e, t) {
      for (var n in t) {
        o.o(t, n) && !o.o(e, n) && Object.defineProperty(e, n, {
          enumerable: !0,
          get: t[n]
        });
      }
    }, o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, o.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var i = {};
    return function () {
      "use strict";

      o.r(i), o.d(i, {
        default: function _default() {
          return _;
        },
        start: function start() {
          return O;
        }
      });

      var e = o(787),
          t = o.n(e),
          n = o(606),
          r = function () {
        function e() {
          var e = this;
          this.callbacks = {}, window.onmessage = function (t) {
            e.callbacks[t.data.type] && e.callbacks[t.data.type](t.data);
          };
        }

        return e.prototype.on = function (e, t) {
          return this.callbacks[e] = t, this;
        }, e.prototype.resetCallbacks = function () {
          return this.callbacks = {}, this;
        }, e;
      }(),
          a = "iframeInitialize",
          u = "iframeFinish",
          c = "iframeError",
          l = "iframeStart",
          s = "iframeLoaded",
          f = "iframeSubmitted";

      function p(t) {
        var n = function (e, t) {
          var n = "function" == typeof Symbol && e[Symbol.iterator];
          if (!n) return e;
          var r,
              o,
              i = n.call(e),
              a = [];

          try {
            for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) {
              a.push(r.value);
            }
          } catch (e) {
            o = {
              error: e
            };
          } finally {
            try {
              r && !r.done && (n = i.return) && n.call(i);
            } finally {
              if (o) throw o.error;
            }
          }

          return a;
        }((0, e.useState)(t), 2),
            r = n[0];

        return {
          setContextRef: n[1],
          postInitialize: function postInitialize(e) {
            return r.postMessage({
              type: a,
              data: e
            }, "*");
          },
          postLoaded: function postLoaded(e) {
            return r.postMessage({
              type: s,
              data: e
            }, "*");
          },
          postStarted: function postStarted(e) {
            return r.postMessage({
              type: l,
              data: e
            }, "*");
          },
          postFinished: function postFinished(e) {
            return r.postMessage({
              type: u,
              data: e
            }, "*");
          },
          postSubmitted: function postSubmitted(e) {
            return r.postMessage({
              type: f,
              data: e
            }, "*");
          },
          postAborted: function postAborted(e) {
            return r.postMessage({
              type: c,
              data: e
            }, "*");
          }
        };
      }

      var _d = function d() {
        return _d = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) {
            for (var o in t = arguments[n]) {
              Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            }
          }

          return e;
        }, _d.apply(this, arguments);
      },
          h = function h(e, t) {
        var n = "function" == typeof Symbol && e[Symbol.iterator];
        if (!n) return e;
        var r,
            o,
            i = n.call(e),
            a = [];

        try {
          for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) {
            a.push(r.value);
          }
        } catch (e) {
          o = {
            error: e
          };
        } finally {
          try {
            r && !r.done && (n = i.return) && n.call(i);
          } finally {
            if (o) throw o.error;
          }
        }

        return a;
      },
          y = {
        width: "200px",
        height: "56px"
      },
          v = {
        overflow: "hidden"
      },
          b = {
        border: 0,
        boxShadow: "none",
        outline: "none",
        overflow: "hidden"
      },
          m = {
        position: "fixed",
        top: "0px",
        right: "0px",
        bottom: "0px",
        left: "0px",
        width: "100%",
        height: "100%",
        margin: "0px",
        padding: "0px",
        zIndex: 1e5
      };

      function g(e) {
        var t = _d(_d({}, y), b);

        return e ? _d(_d({}, t), m) : t;
      }

      var w = "passbase-verify-button";

      function O() {
        document.getElementById(w).contentWindow.postMessage({
          type: a
        }, "*");
      }

      var _ = function _(o) {
        var i = o.onStart,
            b = o.onFinish,
            m = o.onSubmitted,
            O = o.onError,
            _ = function (e, t) {
          var n = {};

          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          }

          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;

            for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
              t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
            }
          }

          return n;
        }(o, ["onStart", "onFinish", "onSubmitted", "onError"]),
            j = h((0, e.useState)(!1), 2),
            S = j[0],
            P = j[1],
            M = p(),
            E = M.setContextRef,
            x = M.postInitialize;

        return function (t) {
          var n = t.onInitialized,
              o = t.onLoaded,
              i = t.onStarted,
              p = t.onFinished,
              d = t.onSubmitted,
              h = t.onAborted;
          (0, e.useEffect)(function () {
            new r().on(a, function (e) {
              var t = e.data;
              return n(t);
            }).on(s, function (e) {
              var t = e.data;
              return o(t);
            }).on(l, function (e) {
              var t = e.data;
              return i(t);
            }).on(u, function (e) {
              var t = e.data;
              return p(t);
            }).on(f, function (e) {
              var t = e.data;
              return d(t);
            }).on(c, function (e) {
              var t = e.data;
              return h(t);
            });
          });
        }({
          onLoaded: function onLoaded() {
            x(_d(_d({}, _), {
              version: "1.1.0",
              iframeBoundingRect: document.getElementById(w).getBoundingClientRect()
            }));
          },
          onStarted: function onStarted() {
            P(!0), null == i || i();
          },
          onFinished: function onFinished() {
            P(!1), null == b || b();
          },
          onSubmitted: function onSubmitted() {
            null == m || m();
          },
          onAborted: function onAborted(e) {
            P(!1), null == O || O.apply(void 0, function () {
              for (var e = [], t = 0; t < arguments.length; t++) {
                e = e.concat(h(arguments[t]));
              }

              return e;
            }(e));
          }
        }), t().createElement(t().Fragment, null, t().createElement(n.ZP, {
          isActive: S,
          accountForScrollbars: !1
        }), t().createElement(n.in, null, t().createElement("div", {
          style: _d(_d({}, y), v)
        }, t().createElement("iframe", {
          id: w,
          style: g(S),
          title: "Passbase Verify Button",
          src: "https://verify-in-browser.cdn.pb-prod.net/v1/controller.html",
          ref: function ref(e) {
            e && E(e.contentWindow);
          },
          allow: "microphone; camera; clipboard-write"
        }))));
      };
    }(), i;
  }();
});